define([
    './directives/PAQuickAddressLookupState',
    './directives/PAQuickAddressLookupFailureState',
    './directives/PAQuickAddressListState',
    './directives/PAQuickAddressZipLookupState',
    './directives/PAQuickAddressAddressInputState',
    './directives/PAQuickAddressStreetInputState',
    './directives/PAQuickAddressInfoState',
    './directives/PAQuickAddressTile',
    './directives/PAQuickAddressInvalidState'
], (
    PAQuickAddressLookupState,
    PAQuickAddressLookupFailureState,
    PAQuickAddressListState,
    PAQuickAddressZipLookupState,
    PAQuickAddressAddressInputState,
    PAQuickAddressStreetInputState,
    PAQuickAddressInfoState,
    PAQuickAddressTile,
    PAQuickAddressInvalidState
) =>{
    angular.module('edge.quoteandbind.quickquote.pa.tiles.address', [])
        .directive('gwPaQuickAddressLookupState', PAQuickAddressLookupState)
        .directive('gwPaQuickAddressLookupFailureState', PAQuickAddressLookupFailureState)
        .directive('gwPaQuickAddressListState', PAQuickAddressListState)
        .directive('gwPaQuickAddressZipLookupState', PAQuickAddressZipLookupState)
        .directive('gwPaQuickAddressAddressInputState', PAQuickAddressAddressInputState)
        .directive('gwPaQuickAddressStreetInputState', PAQuickAddressStreetInputState)
        .directive('gwPaQuickAddressInfoState', PAQuickAddressInfoState)
        .directive('gwPaQuickAddressTile', PAQuickAddressTile)
        .directive('gwPaQuickAddressInvalidState', PAQuickAddressInvalidState);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/address/app.js
 **/